// ════════════════════════════════════════════════════════════
// Sentry init — ECR
// ════════════════════════════════════════════════════════════
// No-op si VITE_SENTRY_DSN est vide (cas par défaut en dev local).
// À activer en remplissant le DSN dans .env.local et les secrets
// GitHub Actions / Cloudflare Pages pour la prod.
// ════════════════════════════════════════════════════════════
import * as Sentry from '@sentry/react';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.info('[Sentry] DSN non défini — monitoring désactivé');
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      // App financière : on masque tout le texte (noms clients, montants, NIF,
      // n° chèque…) et on bloque les médias (photos factures/chèques/SWIFT)
      // dans les session replays — données sensibles, pas de fuite vers Sentry.
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance monitoring : 10% des transactions
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session replay : 10% normal, 100% si erreur
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Filtre des erreurs bruyantes (extensions Chrome, etc.)
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
  });
}
